import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { api } from "../lib/api";

export function InstagramStrip() {
    const [tiles, setTiles] = useState([]);
    useEffect(() => {
        api.get("/instagram-tiles").then(({ data }) => setTiles(data || [])).catch(() => setTiles([]));
    }, []);
    if (!tiles.length) return null;
    return (
        <section className="bg-beige py-14 lg:py-20" data-testid="instagram-strip">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-8">
                    <div>
                        <span className="label-eyebrow flex items-center gap-2"><Instagram size={12} /> Follow us</span>
                        <h2 className="mt-2 font-display text-3xl sm:text-4xl text-inkDark tracking-tight">@sukaanyas</h2>
                    </div>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="label-eyebrow text-skyblueDeep" data-testid="instagram-follow-link">View on Instagram &rarr;</a>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 lg:gap-4">
                    {tiles.map((t) => (
                        <a
                            key={t.id}
                            href={t.linkUrl || "https://instagram.com/sukaanyas"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group relative aspect-square rounded-xl overflow-hidden bg-ivory shadow-soft cursor-pointer"
                            data-testid={`instagram-tile-${t.id}`}
                        >
                            <img src={t.imageUrl} alt={t.caption || "@sukaanyas"} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                            <div className="absolute inset-0 bg-skyblueDeep/0 group-hover:bg-skyblueDeep/30 transition-colors flex items-center justify-center">
                                <Instagram size={20} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
